/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon20Light = forwardRef('UiFrameSizeMinIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.5 2a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 14.5 7h3a.5.5 0 0 1 0 1h-3A2.5 2.5 0 0 1 12 5.5v-3a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M2.5 12a.5.5 0 0 0 0 1h3A1.5 1.5 0 0 1 7 14.5v3a.5.5 0 0 0 1 0v-3A2.5 2.5 0 0 0 5.5 12h-3Z" }),
        React.createElement("path", { d: "M14.5 12a2.5 2.5 0 0 0-2.5 2.5v3a.5.5 0 0 0 1 0v-3a1.5 1.5 0 0 1 1.5-1.5h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { d: "M8 2.5a.5.5 0 0 0-1 0v3A1.5 1.5 0 0 1 5.5 7h-3a.5.5 0 0 0 0 1h3A2.5 2.5 0 0 0 8 5.5v-3Z" })));
});
